import { Component, OnInit, ChangeDetectorRef, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { first, take, takeUntil } from 'rxjs/operators';
import { DateSchedule } from '../../store/programs.era';
import { FilterDialogComponentParams } from 'src/app/components/filters/filters-ui.models';
import { filterPageTypes } from 'src/app/store/filters.era';
import { FiltersDialogComponent } from 'src/app/components/filters/filters-dialog.component';
import { unfilteredMultiTimelineReselector } from 'src/app/store/reselectors/onsiteTimeline.reselector';
import { str2Date,  addDaysToDate } from 'globals/helpers/helpers';
import { onsiteReselector } from 'src/app/store/reselectors/onsite.reselector';
import { ViewActivityDialogComponent, ViewActivityDialogData } from './onsite.dialog.viewActivity.component';
import { ViewProgramDialogComponent } from './onsite.dialog.viewProgram.component';
import { PAGE_NAME } from 'src/app/services/event.permissions.service';
import { ossCanManageProgramReselector } from 'src/app/store/reselectors/permissions.reselector';
import { OnsiteScheduleEntry, OnsiteTimelineBrick, ProgramNode } from 'globals/store/onsite.data';
import { openDialogGetResult } from 'src/app/helpers/angular-helpers';
import { myScheduleFullSingleTimelineReselector } from 'src/app/store/reselectors/onsite.myschedule.reselector';
import { ManageProgramComponent } from '../manage/manage-program.component';
import { ManageSessionData, ManageSessionComponent } from '../manage/manage-session.component';
import { ViewSessionDialogData, ViewSessionDialogComponent } from './onsite.dialog.viewSession.component';
import { Wrapper } from 'src/app/components/wrapper.component';
import { ManageProgramData } from 'globals/store/programs.data';
import { OnSiteBuilderComponent } from './onsite.builder.component';
import { OnsiteTimelineComponent } from './onsite.timeline.component';
import { ViewSetupDialogComponent, ViewSetupDialogData } from './onsite.dialog.viewSetup.component';
import { onsiteActions, onsiteFeatures } from 'src/app/store/onsite.era';
import { traceNames } from 'src/app/services/performance.tracking.data';
import { TopMenuComponent } from '../program/top.menu';
import { MobileMenuComponent } from 'src/app/components/menu/mobile-menu.component';
import { IconComponent } from 'src/app/components/icon/icon.component';
import { MessagePanelComponent } from 'src/app/components/message-panel';
import { LoaderPaneFragmentComponent } from 'src/app/components/loader/loader-pane-fragment.component';
import { CommonModule } from '@angular/common';
import { DropdownComponent } from 'src/app/components/misc/dropdown.component';
import { ZoomWrapper } from 'src/app/components/wrappers/zoom-wrapper.component';
import { FindByIdPipe } from 'src/app/services/pipes/findById.pipe';
import { DatetimeComponent } from 'src/app/components/datetime.component';
import { lastValueFrom } from 'rxjs';

@Component({
    selector: 'app-onsite',
    templateUrl: './onsite.page.html',
    styleUrls: ['./onsite.page.scss', '../../page.scss'],
    standalone: true,
    imports: [TopMenuComponent, DropdownComponent, DatetimeComponent, FindByIdPipe, ZoomWrapper, OnsiteTimelineComponent, OnSiteBuilderComponent, MobileMenuComponent, IconComponent, MessagePanelComponent, LoaderPaneFragmentComponent, CommonModule],
})
export class OnSitePageComponent extends Wrapper<OnSitePageComponent> implements OnInit {

		filtersCount: number
    labels = [];
    message = '';
    currentPage: 'build' | 'timeline' = 'build';
    viewMySchedule = false;
    readonly
		detailedMode = true;
		isOnMenu = true
		timelineViews = [];
		dateId: string
		date: Date
		dateEntries: OnsiteScheduleEntry[][]
		routerLink_for_program = 'dashboard';
		unfilteredMultiTimeline: DateSchedule
		filterType: string = filterPageTypes.onsiteTimeline
    activitiesLoaded: boolean
    programNodeCentersById: Map<String, ProgramNode>
    isProgramOrLogistics = false
    page_name = PAGE_NAME.schedules
    traceNames = traceNames;
    ready = false;

    showTimeline = true
    showDatesMenu = false
    autoNavigated = false
    @ViewChild('onsiteBuilder') onsiteBuilder: OnSiteBuilderComponent
    @ViewChild('onsiteTimeline') onsiteTimeline: OnsiteTimelineComponent

    constructor(private route: ActivatedRoute, private changeDetectorRef: ChangeDetectorRef) {
        super()
        // setTimeout(()=>{
          this.currentPage = /timeline|my_schedule/.test(this.router.url) ? 'timeline' : 'build';

          if (this.currentPage === 'timeline') {
            this.isOnMenu = false
          }
        // },0)
        // console.log("Initializing... ", this.currentPage)

        if(/my_schedule/.test(this.router.url)){
          this.viewMySchedule = true;
          this.isOnMenu = false
          this.filterType = filterPageTypes.onsiteMySchedule; // this does not do what I thought it would <== yeah, it only helps the onsite menu component know which filters data to pull from to see if it's active or not.
        }
        this.uiService.changePageTitle(this.viewMySchedule ? 'My Schedule' : this.isOnMenu ? 'On Site Builder' : 'On Site Timeline', true)

        if (this.viewMySchedule) {
          this.subCallback(this.store.select(myScheduleFullSingleTimelineReselector), singleTimeline => this.showTimeline = !!singleTimeline.length)
        }

        this.subCallback(this.route.params, async (params) => {
          console.log({params})
          if (params.dateIndex) {
            this.dateId = params.dateIndex
            this.changeDetectorRef.markForCheck();
            this.date = str2Date(this.dateId)
            this.store.dispatch(onsiteActions.changeOnsiteDateString({dateString: params.dateIndex}))
            const date = await lastValueFrom(this.store.select(onsiteFeatures.selectSelectedDateString).pipe(take(1)))
            this.isOnMenu = false
          } else {
            this.isOnMenu = true
          }
          // this.performanceService.stop(this.traceNames.viewOnSiteScheduleBuilder) // it gets started when the different programs are selected
        });
    }
    
    ngOnInit() {
      setTimeout(() => {
        this.ready = true
      }, 3000);
      this.subProp(this.store.select(ossCanManageProgramReselector), 'isProgramOrLogistics')
			this.subProp(this.store.select(unfilteredMultiTimelineReselector), 'unfilteredMultiTimeline')
      this.subCallback(this.store.select('events','event'), event => this.readonly = !event || event.is_readonly)
			this.subCallback(this.store.select(onsiteReselector), ({ dateEntries, programNodeCentersById }) => {
        console.log('onsite reselector fired', { dateEntries, programNodeCentersById })
        this.showDatesMenu = dateEntries.length && (dateEntries.length > 1 || dateEntries[0].length > 1)
        this.dateEntries = dateEntries
        this.checkForAutoNavigate()
        this.programNodeCentersById = programNodeCentersById
			})

      this.subProp(this.store.select('onsite', 'activitiesLoaded'), 'activitiesLoaded')
			this.subProp(this.store.select('filters','onsiteTimeline','count'), 'filtersCount')

			if (window.innerWidth <= 768 /* && this.eventService && this.eventService.CURRENT_EVENT && this.eventService.CURRENT_EVENT.dates && this.eventService.CURRENT_EVENT.dates.length */) {
					this.routerLink_for_program = 'timeline';
			}

    }
    
    async checkForAutoNavigate() {
      if (this.showDatesMenu || !this.dateEntries.length || this.currentPage !== 'build' || this.autoNavigated) return
      this.autoNavigated = true // must be set before the await below
      const entry = this.dateEntries[0][0]
      const params = await this.route.params.pipe(first()).toPromise()
      if (!params.dateIndex) {
        console.log("Auto navigating...", { params, entry })
        this.showSchedule(entry)
      }
    }

		trackByFn(index, item) {
				// DON'T REMOVE THIS LIKE YOU ONCE DID.  INSTEAD, FIGURE OUT WHY IT IS CALLED SO MUCH
				return index; // or item.id
		}

    showSchedule(entry) {
      console.log(entry)
      this.store.dispatch(onsiteActions.changeOnsiteDateString(entry.id))
			this.router.navigate(['/event/onsite', this.viewMySchedule ? 'my_schedule' : this.currentPage, this.eventService.eventId, entry.id])
    }
    hideSchedule() {
			this.isOnMenu = true
      this.store.dispatch(onsiteActions.changeOnsiteDateString(null))
			this.router.navigate(['/event/onsite', this.viewMySchedule ? 'my_schedule' : this.currentPage, this.eventService.eventId])
    }

    async openProgramDetail(evt, callerData) {
      if (evt) {
        evt.stopPropagation();
        if (evt.target.nodeName === 'ICON') { return; }
      }
      if (!callerData) return
      const { scheduleId, ossView } = callerData
      if (!scheduleId) return
      const program = this.programService.programs.find(p => p.id === scheduleId);
      if (!program) return
      if (this.isProgramOrLogistics && this.currentPage === 'build') {
        const data: ManageProgramData = { programId: program.id, fromOss: true }
        this.changeDetectorRef.detach()
        const dateChanged = await openDialogGetResult(this.dialog, ManageProgramComponent, { autoFocus: false, disableClose: true, data, panelClass: 'full-screen-modal' })
        if (dateChanged && ossView.length === 1) { // return to menu if the only schedule's date has changed
            this.hideSchedule()
        }
        this.changeDetectorRef.reattach()
      } else {
        this.dialog.open(ViewProgramDialogComponent, { width: '480px', maxHeight: '90vh', data: program})
      }
    }
    async openSessionDetail({scheduleId, id}) {
        if (!scheduleId || !id) { return; }
        if (this.currentPage === 'build') {
          const data: ManageSessionData = { sessionId: id }
          this.changeDetectorRef.detach()
          await openDialogGetResult(this.dialog, ManageSessionComponent, { autoFocus: false, disableClose: true, data, panelClass: 'full-screen-modal' })
          this.changeDetectorRef.reattach()
        } else { 
          const program = this.programService.programs.find(p => p.id === scheduleId);
          // console.log(program, sessionId, program.sessions_obj[sessionId])
          const session =  program.sessions_obj[id]
          const data: ViewSessionDialogData = {
            program,
            session,
            date: addDaysToDate(str2Date(program.date), +session.on_day - 1),
          }
          this.dialog.open(ViewSessionDialogComponent, { width: '480px', maxHeight: '90vh',
            autoFocus:false, data })
        }
    }
    openBrickDetail(brick: OnsiteTimelineBrick) {
      if (brick.type === 'session') {
        this.openSessionDetail({scheduleId: brick.scheduleId, id: brick.id });
        return
      } 
      
      const node = this.programNodeCentersById.get(brick.scheduleId)
      const program = node.schedule
    
      if (brick.type === 'activity') {
        const data: ViewActivityDialogData = {
          program,
          activityId: brick.id,
          date: program.date,
          scheduleTitle: brick.schedule_title
        }
        // console.log({ data, brick, node, nodeCenters: this.programNodeCentersById })
        this.dialog.open(ViewActivityDialogComponent, { width: '480px', maxHeight: '90vh', data })
      } else if (brick.type === 'access' || brick.type === 'clear') {
        const data: ViewSetupDialogData = {
          program,
          setupId: brick.id,
          date: program.date,
          type: brick.type
        }
        this.dialog.open(ViewSetupDialogComponent, { width: '480px', maxHeight: '90vh', data })
      }
    }

    async filter() {
      const filterGroupings = await this.filtersService.buildFullOnsiteTimelineFilterUI(filterPageTypes.onsiteTimeline)
      const params: FilterDialogComponentParams = {width: '770px', autoFocus: false, data: { filterPage: filterPageTypes.onsiteTimeline, filterGroupings }}
      this.dialog.open(FiltersDialogComponent, params)
    }

}
